import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import FormatCheckTextBox from '../../../common/component/FormatCheckTextBox'
import Window from '../../../common/Window'

class CommonEmailChange extends Component {
  constructor (props) {
    super(props)
    this.state = {currentEmail: '', newEmail: '', newEmailVerification: '', newEmailOK: false, newEmailVerificationOK: false}
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  componentWillMount () {
    AWSAPI.getUserAttributes(this.userRole, (err, result) => {
      if (err) {
        // console.log(err) //デバッグ時以外はコメントアウト
        return
      }
      const currentEmail = result.filter((e) => e.Name === 'email')[0].Value
      this.setState({
        currentEmail: currentEmail
      })
    })
  }
  changed (name, e, isError) {
    this.setState({[name]: e.target.value, [name + 'OK']: !isError})
  }
  getErrorMessageDisplayValue (text) {
    if (text.length === 0) return 'none'
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    return emailPattern.test(text) ? 'none' : 'inherit'
  }
  changeEmail (currentEmail, newEmail) {
    const onSuccess = (res) => {
      Window.alert('メールアドレスを変更しました。', () => {
        this.props.history.push('/' + this.userRoleUrl + '/personal_setting_home/')
        Window.closeDialog()
      })
    }
    const params = {
      currentEmail: currentEmail,
      newEmail: newEmail
    }
    console.log(params)
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  onChangeEmail (e) {
    e.preventDefault()
    const currentEmail = this.state.currentEmail.trim()
    const newEmail = this.state.newEmail.trim()
    const newEmailVerification = this.state.newEmailVerification.trim()
    if (newEmail === currentEmail) {
      Window.alert('現在と異なるメールアドレスを入力してください')
      return false
    }
    if (newEmail === '') {
      Window.alert('新しいメールアドレスを入力してください')
      return false
    }
    if (newEmail !== newEmailVerification) {
      Window.alert('新しいメールアドレスが新しいメールアドレス(確認用)と一致しません')
      return false
    }
    if (!newEmail.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/)) {
      Window.alert('正しいメールアドレスの形式で入力してください')
      return false
    }
    this.changeEmail(currentEmail, newEmail)
    return false
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/' + this.userRoleUrl + '/personal_setting_home/')
        break
      default:
        break
    }
  }
  renderNotificationSetting () {
    const currentEmail = this.state.currentEmail
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    const disabledStatus = (this.state.newEmailOK && this.state.newEmailVerificationOK) ? '' : 'disabled'
    return (
      <div>
        <form className='form-horizontal' method='post'>
          <div className='container'>
            <div className='alert alert-block alert-info'>
              <p>必要な情報を選択して最後に「メールアドレスを変更する」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
            </div>
            <fieldset>
              <legend>メールアドレスの変更</legend><br />
              <div className='control-group'>
                <label className='control-label'>現在のメールアドレス</label>
                <div className='controls'>{currentEmail}</div>
              </div>
              <div className='control-group'>
                <label className='control-label'>新しいメールアドレス <span className='required'>*</span></label>
                <div className='controls'>
                  <FormatCheckTextBox className='span5' value={this.state.newEmail} autoComplete='false' onChange={(e, isError) => this.changed('newEmail', e, isError)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
                </div>
              </div>
              <div className='control-group'>
                <label className='control-label'>新しいメールアドレス <span className='required'>*</span><br />(確認用)</label>
                <div className='controls'>
                  <FormatCheckTextBox className='span5' value={this.state.newEmailVerification} autoComplete='false' onChange={(e, isError) => this.changed('newEmailVerification', e, isError)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
                </div>
              </div>
            </fieldset>
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary btn-l' name='action' value='CONFIRM' onClick={e => this.onChangeEmail(e)} disabled={disabledStatus}>メールアドレスを変更する</button>
            </footer>
          </div>
        </form>
      </div>
    )
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span7'>
              <header className='page-header'>
                <h3>メールアドレスの変更<br /><small>こちらでメールアドレスを設定できます。</small></h3>
              </header>
            </div>
            <div className='span9'>
              <ul className='nav nav-pills'>
                <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
  render () {
    const notificationSetting = this.renderNotificationSetting()
    return (
      <div>
        {this.renderPageNavi()}
        <section className='page container'>
          {notificationSetting}
        </section>
      </div>
    )
  }
}

export default CommonEmailChange



// WEBPACK FOOTER //
// ./src/common/pages/secure/EmailChange.js